// Auto-generated config for dev environment
export const API_BASE_URL = 'https://bonder.lyndus.dev';
export const APP_USER_URL = 'https://appuser.lyndus.dev';
export const BM_URL = 'https://bm.lyndus.dev';
export const BS_URL = 'https://bs.lyndus.dev';
export const CLIENT_URL = 'https://client.lyndus.dev';
export const BONDER_URL = 'https://bonder.lyndus.dev';
export const BANKING_URL = 'https://banking.lyndus.dev';
export const ENVIRONMENT = 'dev';
export const IS_PRODUCTION = 'dev' === 'prod';

// Original config exported below for reference
export const API_URL = process.env.VUE_APP_API_URL
export default API_URL
